import React, { useEffect, useState } from "react";
import Book from "../components/Books/Book";
import Title from "../components/Title";
import { useQuery } from "react-query";
import { API } from "../config/api";
import ScreenLoader from "../components/Skeleton/ScreenLoader";
import NoData from "../components/Skeleton/NoData";
import Pagination from "../components/Pagination/Pagination";

function Library(props) {
  const [page, setpage] = useState(1);
  const { isLoading, error, data: bookData, refetch } = useQuery(
    "getLibraries",
    () => API.get(`/libraries?page=${page}&limit=8`)
  );
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setpage(selectedPage + 1);
  };

  useEffect(() => {
    setpage(page);
    refetch();
  }, [page]);

  return (
    <div className="">
      <div className="">
        {/* Library */}
        <Title name="My Library" />
      </div>
      {/* card */}
      {isLoading || !bookData ? (
        <ScreenLoader />
      ) : error ? (
        <h1>{error.message}</h1>
      ) : bookData.data.data.length === 0 ? (
        <NoData />
      ) : (
        <>
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 md:gap-10">
            {bookData.data.data.map((books, index) => (
              <Book key={index} data={books.book} />
            ))}
          </div>
          <div className="flex w-full justify-center mt-6">
            <Pagination
              handleChangePage={handlePageClick}
              pageCount={bookData.data.totalPages}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Library;
